/*
  Bloom reveal — reusable scroll-in stagger, cross-browser (IntersectionObserver).
  Elements with [data-bloom-reveal-group] arm a hidden state ONLY once JS runs
  (so no-JS users always see content, and there's no flash), then reveal their
  children with a per-child stagger when scrolled into view. Children set their
  order via the CSS var --bloom-i. Respects prefers-reduced-motion.
*/
(function () {
  var groups = document.querySelectorAll('[data-bloom-reveal-group]');
  if (!groups.length) return;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reduce) {
    // Show everything immediately; never leave content hidden.
    groups.forEach(function (g) { g.classList.add('is-revealed'); });
    return;
  }

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  groups.forEach(function (g) {
    g.classList.add('bloom-reveal-armed');
    io.observe(g);
  });
})();
